module.exports = __webpack_public_path__ + "static/media/Gagey3.f37704e9.jpg";